<template>
  <div class="app-container">
    <div class="activity-list-filter">
      <el-row>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="区域" v-model="filter.regionName" size="medium" :disabled="filterDisable.regionName" clearable>
               <el-option
                v-for="item in regionOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
         <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="市场" v-model="filter.marketId" size="medium" :disabled="filterDisable.marketId" clearable>
               <el-option
                v-for="item in marketOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="总经理" v-model="filter.gmEid" size="medium" :disabled="filterDisable.gmEid" clearable>
               <el-option
                v-for="item in GMOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="营运总监" v-model="filter.doEid" :disabled="filterDisable.doEid" size="medium" clearable>
              <el-option
                v-for="item in DOOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
         <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="营运经理" v-model="filter.omEid" :disabled="filterDisable.omEid" size="medium" clearable>
              <el-option
                v-for="item in OMOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="营运顾问" v-model="filter.ocEid" :disabled="filterDisable.ocEid" size="medium" clearable>
              <el-option
                v-for="item in OCOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="grid-content">
            <el-input @keyup.enter.native="loadData(true)" class="activity-list-filter-value" placeholder="餐厅国际编号" v-model="filter.storeCode" :disabled="filterDisable.storeCode" size="medium" />
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-input @keyup.enter.native="loadData(true)" class="activity-list-filter-value" placeholder="餐厅名称" v-model="filter.storeName" :disabled="filterDisable.storeName" size="medium" />
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-input @keyup.enter.native="loadData(true)" class="activity-list-filter-value" placeholder="员工编号" v-model="filter.unionId" size="medium" />
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-input @keyup.enter.native="loadData(true)" class="activity-list-filter-value" placeholder="员工姓名" v-model="filter.nickName" size="medium" />
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="身份" v-model="filter.identity" size="medium" clearable>
              <el-option
                v-for="item in identityOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="助力状态" v-model="filter.hasBoosted" size="medium" clearable>
              <el-option
                v-for="item in boostStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div>
            <el-button class="activity-list-filter-search" size="medium" @click="loadData(true)">立即筛选</el-button>
            <el-button class="activity-list-filter-reset" size="medium" @click="clearFilter([])">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <avue-crud
        :page="pageItem"
        :data="displayData"
        @current-change="pageItem.currentPage=$event;loadData()"
        @size-change="pageItem.pageSize=$event;loadData(true)"
        :option="spaceshipRecordListOption"
        :table-loading="loading">
        <template slot="menuLeft">
          <el-button class="filter-item"
            @click="handleExport()"
            size="small"
            type="primary"
            :loading="exportLoading"
            icon="el-icon-download">{{exportName}}
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>

import { spaceshipRecordListOption } from '@/const/crud/manager-contest/spaceshipRecord';
import { fetchSpaceshipBoostRecordList, exportSpaceshipBoostRecord } from '@/api/manager-contest/manager-contest';
import { identityOptions } from '@/const/crud/activity/activity';
import { fetchActivityFilterOptions, fetchActivityFilter } from '@/api/activity/activity';
import { exporting } from '@/util/exportUtil'

export default {
  data() {
    return {
      data: [],
      pageItem: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      loading: false,
      identityOptions,
      spaceshipRecordListOption,
      boostStatusOptions: [
        {label: '未助力', value: false},
        {label: '已助力', value: true}
      ],
      filter: {
        regionName: '',
        marketId: '',
        gmEid: '',
        doEid: '',
        omEid: '',
        ocEid: '',
        storeCode: '',
        storeName: '',
        positionId: '',
        unionId: '',
        nickName: '',
        identity: '',
        hasBoosted: ''
      },
      filterOption: {},
      filterDisable: {},
      notClearOptions: false,
      marketOptions: [],
      regionOptions: [],
      GMOptions: [],
      DOOptions: [],
      OMOptions: [],
      OCOptions: [],
      storeOptions: [],
      exportName: '导出',
      exportLoading: false,
    }
  },
  async created() {
    await this.loadFilterOptions();
    await this.loadData(true);
  },
  computed: {
    displayData() {
      const data = JSON.parse(JSON.stringify(this.data));
      data.forEach(item => {
        if (!item.regionName) {
          item.regionName = '--';
        }
        if (!item.marketName) {
          item.marketName = '--';
        }
        if (!item.gmName) {
          item.gmName = '--';
        }
        if (!item.doName) {
          item.doName = '--';
        }
        if (!item.omName) {
          item.omName = '--';
        }
        if (!item.ocName) {
          item.ocName = '--';
        }
        if (!item.storeCode) {
          item.storeCode = '--';
        }
        if (!item.storeName) {
          item.storeName = '--';
        }
        if (!item.unionId) {
          item.unionId = '--';
        }
        if (!item.nickName) {
          item.nickName = '--';
        }
        if (!item.identity) {
          item.identity = '--';
        }
        if (!item.position) {
          item.position = '--';
        }
        item.hasBoosted = (item.hasBoosted ? '已助力': '未助力')
         
      });
      return data;
    }
  },
  watch: {
    'filter.regionName': {
      handler(val) {
        if (!this.notClearOptions) {
          const excludedClearOptions = ['regionName', 'storeCode',];
          this.clearOptions(excludedClearOptions);
        }
        this.marketOptions = this.filterOption.markets.filter(x => x.parentId === val);
      }
    },
    'filter.marketId': {
      handler(val) {
        if (!this.notClearOptions) {
          const excludedClearOptions = ['regionName', 'marketId', 'storeCode',];
          this.clearOptions(excludedClearOptions);
        }
        this.GMOptions = this.filterOption.gms.filter(x => x.parentId === val);
      }
    },
    'filter.gmEid': {
      handler(val, oldVal) {
        if (val) {
          this.DOOptions = this.filterOption.dos.filter(x => x.parentId === val);
        } else {
          this.DOOptions = [];
        }
        if ((val && oldVal && val !== oldVal) || !val) {
          this.filter.doEid = '';
        }
      }
    },
    'filter.doEid': {
      handler(val, oldVal) {
        if (val) {
          this.OMOptions = this.filterOption.oms.filter(x => x.parentId === val);
        } else {
          this.OMOptions = [];
        }
        if ((val && oldVal && val !== oldVal) || !val) {
          this.filter.omEid = '';
        }
      }
    },
    'filter.omEid': {
      handler(val, oldVal) {
        if (val) {
          this.OCOptions = this.filterOption.ocs.filter(x => x.parentId === val);;
        } else {
          this.OCOptions = [];
        }
        if ((val && oldVal && val !== oldVal) || !val) {
          this.filter.ocEid = '';
        }
      }
    }
  },
  methods: {
    async loadData(init) {
      this.loading = true;
      this.pageItem.currentPage = init ? 1 : this.pageItem.currentPage;
      const page = {
        current: this.pageItem.currentPage,
        size: this.pageItem.pageSize,
      };
      const filter = Object.assign(JSON.parse(JSON.stringify(this.filter)), page);
      await fetchSpaceshipBoostRecordList(filter).then(response => {
        if (response.data && response.data.code === 0 && response.data.data) {
          this.data = response.data.data.records;
          this.pageItem.total = response.data.data.total;
          this.loading = false;
        }
      });
    },
    async loadFilterOptions() {
      await fetchActivityFilterOptions().then(response => {
        if (response.data && response.data.code === 0) {
          this.filterOption = response.data.data;
          this.regionOptions = this.filterOption.regions;
        }
      });
      await fetchActivityFilter().then(res => {
        const result = res.data.data;
        if(!result) {
          return;
        }
        if (result.roleType === 'OC_OM_DO') {
          this.notClearOptions = true;
          this.generateFilter(result.eid);
        } else if (result.roleType === 'STORE_MANAGEMENT') {
          this.notClearOptions = true;

          this.filterDisable.regionName = true;
          this.filterDisable.marketId = true;
          this.filterDisable.gmEid = true;
          this.filterDisable.doEid = true;
          this.filterDisable.omEid = true;
          this.filterDisable.ocEid = true;
          this.filterDisable.storeCode = true;
          this.filterDisable.storeName = true

          this.filter.regionName = result.regionName || '';
          this.filter.marketId = result.marketId || '';
          this.filter.gmEid = result.gmEid || '';
          this.filter.doEid = result.doEid || '';
          this.filter.omEid = result.omEid || '';
          this.filter.ocEid = result.ocEid || '';
          this.filter.storeCode = result.usCode || '';
          this.filter.storeName = result.storeName || '';

        }
      });
    },
    generateFilter(eid) {
      let eidKey = eid;
      let filterOcs = this.filterOption.ocs.filter(item => item.eid === eidKey);
      if (filterOcs && filterOcs.length > 0) {
        this.filter.omEid = filterOcs[0].parentId || '';
        this.filterDisable.omEid = true;
        eidKey = this.filter.omEid;
      }

      let filterOms = this.filterOption.oms.filter(item => item.eid === eidKey);
      if (filterOms && filterOms.length > 0) {
        this.filter.doEid = filterOms[0].parentId;
        this.filterDisable.doEid = true;
        eidKey = this.filter.doEid;
      }

      let filterDos = this.filterOption.dos.filter(item => item.eid === eidKey);
      if (filterDos && filterDos.length > 0) {
        this.filter.gmEid = filterDos[0].parentId;
        this.filterDisable.gmEid = true;
        eidKey = this.filter.gmEid;
      }

      let filterGms = this.filterOption.gms.filter(item => item.eid === eidKey);
      if (filterGms && filterGms.length > 0) {
        this.filter.marketId = filterGms[0].parentId;
        this.filterDisable.marketId = true;
        eidKey = this.filter.marketId;
      }

      let filterMarkets = this.filterOption.markets.filter(item => item.eid === eidKey);
      if (filterMarkets && filterMarkets.length > 0) {
        this.filter.regionName = filterMarkets[0].parentId;
        this.filterDisable.regionName = true;
      }
    },
    clearOptions(excluded) {
      this.GMOptions = [];
      this.DOOptions = [];
      this.OMOptions = [];
      this.OCOptions = [];
      this.clearFilter(excluded);
    },
    clearFilter(excludedColumn) {
      let excluded = [];
      excluded = excluded.concat(excludedColumn || []);
      excluded = excluded.concat(Object.keys(this.filterDisable));
      Object.keys(this.filter).forEach(key => {
        if (!excluded || excluded.indexOf(key) < 0) {
          this.filter[key] = '';
        }
      });
      if (!excludedColumn || excludedColumn.length < 1) {
        this.loadData(true);
      }
    },
    handleExport() {
      exportSpaceshipBoostRecord(this.filter).then(response => {
        if (response.status === 200 && response.data && response.data.data) {
          this.exportLoading = true
          this.exportName = "导出中..."
          exporting(response.data.data, this.exportCallback)
        } else {
          this.$message({
            message: '信息导出失败',
            type: 'warning',
            showClose: true,
          });
        }
      });
    },
    exportCallback(result) {
      this.exportLoading = false
      this.exportName = "导出"
      if (result) {
        this.$message({
          showClose: true,
          message: '导出完成',
          type: 'success'
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.activity-list-filter {
  margin: 0 10px;
  &-value {
    width: 96% !important;
  }
  &-reset {
    float: right;
    margin-right: 8px;
  }
  &-search {
    float: right;
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
}
</style>